import { render, staticRenderFns } from "./SoftwareVersion.vue?vue&type=template&id=1efa4f85&"
import script from "./SoftwareVersion.vue?vue&type=script&lang=js&"
export * from "./SoftwareVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports